import {Controller} from "./Controller"
import {Backend} from "./Controller/Backend"
import {Network} from "./Controller/Network"





class Main {
  constructor(hostUrl) {
    this.backend = new Backend ()
    this.network =  new Network (null, hostUrl)
    this.controller =  new Controller (this.backend, this.network)
  }

  get_package(path = null , format , version = null, callback) {
    try {
      return this.controller.get_package (path = null , format , version = null, callback)
    } catch (e) {
      throw new Error ('blendedError')
    }
  }

  save_local (project_object) {
    try {
      return  this.controller.save_local (project_object)
    } catch (e) {
       throw new Error ('blendedError')
    }
  }

  save_hub (blended_project) {
    /* save on hub need to discuss */
    try {
      let project = this.controller.as_jptf (blended_project);
      return this.network.save_hub (project)
    } catch (e) {
       throw new Error ('blendedError')
    }
  }

  validate_local (project_object) {
    try {
      let project =  this.controller.as_jptf (project_object);
      return this.network.validate_local(project)
    }
    catch (e) {
       throw new Error ("BlendedError")
    }
  }

  validate_hub (project_object) {
     try {
       let project =  this.controller.as_jptf (project_object);
       return this.network.validate_hub (project)
     }
     catch (e) {
       throw new Error ("BlendedError")
     }
   }

  save_js (name,content) {
    return this.network.save_js (name , content);
  }

  save_css (name,content) {
    return this.network.save_css (name , content);
  }

  get_image (image_url) {
     return this.network.load_image(image_url);
  }

  load_image (image_url) {
    return this.network.backend.load_image(image_url);
  }

  save_image (image_name ,image_content) {
    return this.network.save_image (image_name,  image_content);
  }

  make_active (body, callback) {
    this.controller.make_active(body.slug)
    this.network.makeActive(body, (data,  response) =>{
        return callback (data, response)
    })
  }

  login (userName,  password , callback) {
    this.network.login (userName,  password , (data, response)=> {
      return callback (data, response)
    })
  }

  userGet (callback) {
    this.network.userGet ((data, response) => {
      return callback(data, response)
    })
  }

  createAccount (body, callback) {
    var _this = this;
    this.network.createAccount (body, (data, response)=> {
        var resp;
        try{
          var resp = JSON.parse(response.text);
        }
        catch(e){
          resp = {};
        }
        if(resp.hasOwnProperty('activationchallenge')){  // question in response
              var answer =  this.controller.generateChallangeResponse(resp.activationchallenge)
              var body1 = {};
              body1["activationSolution"] = answer;
              _this.updateAccount(body["userName"], body1, (dataa,responsee) => {
                if(responsee){
                  if(response.status === 200){
                    return callback(data, response)
                  } else {
                    return callback(dataa, responsee)
                  }
                } else {
                  return callback(dataa, responsee)
                }
                return callback (data, response)
              });
        } else {
          return callback (data, response)
      }
    })
  }
 
  getPackages (opts, callback) {
    this.network.getPackages (opts, (data, response) => {
      return callback (data, response)
    })
  }


  getPackageDetails (accountSlug, pk , callback) {
    this.network.getPackageDetails (accountSlug, pk , (data, response)=> {
      return callback (data, response)
    })
  }

  localDetails (accountSlug, pk , callback) {
    this.network.localDetails (accountSlug, pk , (data, response)=> {
      return callback (data, response)
    })
  }

  downloadDraft (pk , callback) {
    this.network.downloadDraft (pk , (data, response) => {
      return callback (data, response)
    })
  }


  download (pk , callback) {
    this.network.download (pk , (data, response) =>{
      return callback (data, response)
    })
  }


  addRating (pk ,  callback) {
     this.network.addRating(pk, (data, response)=> {
        return callback(data, response)
     })
  }

  getRatings (pk , verbose,  callback) {
     this.network.getRatings (pk,  verbose,  (data, response)=>{
         return callback(data, response)
     })
  }

  getRatingDetails (pk, ratingPk, verbose, callback) {
    this.network.getRatingDetails (pk, ratingPk, verbose , (data, response) =>{
         return callback (data, response)
    })
  }

  updateRating (pk, ratingPk, callback) {
     this.network.updateRating (pk, ratingPk, (data, response)=>{
       return callback (data, response)
     })
  }

  /* licence */
  getLicenses (pk, callback) {
    this.network.getLicenses (pk, (data)=>{
      return callback (data, response)
    })
  }

  removeLicense (pk, name, callback) {
     this.network.removeLicense (pk, name, (data)=>{
       return callback (data, response)
     })
  }

  updateLicense (name, pk, callback) {
    this.network.updateLicense (name, pk, (data, response)=>{
      return callback (data)
    })
  }

  /* accusition */

  acquirePackage (pk, callback) {
    this.network.acquirePackage (pk, (data)=>{
      return callback (data, response)
    })
  }

  //this.network.pullPackage ('140' , false,  (data)=>{})
  pullPackage (accountSlug, pk,  opts, callback) {
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response)
    } else {
      this.controller.pullPackage (accountSlug, pk , opts,  (data, response)=>{
        return callback (data, response)
      })
    }
  }
  //this.network.pushPackage ('140' , {},  (data)=>{})
  pushPackage (accountSlug, pk , body, callback ) {
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response);
    } else {
      this.controller.pushPackage (accountSlug, pk , body, (data, response)=> {
         return callback (data, response)
      })
    }
  }

  clonePackage (accountSlug, slug, newPackageName, callback) {
    // ek naya field add hoga , naye package ka naam
    let body = {"type" : "clone", "newPackageName" : newPackageName}
    this.network.packageShare (accountSlug, slug, body,  (data, response) => {
      return callback (data, response)
    })
  }

  transferPackage (pk,  accountSlug, callback) {
    //accountSlug
    let body = {"type" : "transfer", "accountSlug" :accountSlug}
    this.network.packageShare (pk , body,  (data, response) => {
      return callback (data, response)
    })
  }

  snapshot (package_name, callback) {
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response);
    } else {
        this.controller.snapshot (package_name, (data, response) => {
            return callback (data, response)
        })
    }
  }

  versionCreateSnapshot (accountSlug, slug, body, callback){
    this.controller.versionCreateSnapshot (accountSlug, slug, body, (data, response) => {
      return callback (data, response);
    })
  }


  getCurrentAccount (slug, callback) {
    this.network.getCurrentAccount (slug, (data, response) => {
        return callback (data, response)
    })
  }

  setCurrentAccount (slug, body, callback) {
    this.network.setCurrentAccount (slug, body, (data, response) => {
        return callback (data,  response)
    })
  }

  getAccountList (slug,  callback) {
    this.network.getAccountList (slug, (data, response) => {
      return callback (data, response)
    })
  }

  logout (callback) {
    this.network.logout ((data, response)=> {
      return callback (data, response)
    })
  }

  resetPassword  (body, callback) {
    this.network.resetPassword (body, (data, response) =>{
      return callback (data, response)
    })
  }

  setThemeSetting (data) {
     return this.controller.setThemeSetting (data)
  }

  getThemeSetting () {
     return this.controller.getThemeSetting ()
  }

  getThemeSettings (callback) {
    this.network.getThemeSettings ((data, response)=>{
      return callback (data, response)
    })
  }

  setThemeSettings (opts, callback) {
     this.network.setThemeSettings (opts, (data, response)=>{
       return callback (data, response)
     })
  }

  getThemeSettingPosition (index) {
     return this.controller.getThemeSettingPosition (index)
  }

  doUndo () {
   let data =  this.controller.doUndo ()
   return data
  }

  undoStack () {
    return this.controller.undoStack ()
  }

  redoStack () {
    return this.controller.redoStack ()
  }

  doRedo () {
   let data = this.controller.doRedo ()
   return data
  }

  revert  () {
    let data =  this.controller.revert()
    return data
  }

  pushLocalChanges (data) {
    this.controller.pushLocalChanges (data)
  }

  clearStack () {
    this.controller.clearStack ()
  }

  getDependencies  (slug, callback) {
    this.network.getDependencies ( slug, (data, response)=> {
       return callback (data, response)
    })
  }

  preview (url, callback) {
    this.network.preview (url, (data, response)=> {
      return callback(data, response)
    })
  }

  getFile (accountSlug, slug, fileName, callback) {
    this.controller.getFile (accountSlug, slug, fileName,  (data, response) => {
      return callback (data, response)
    })
  }

  getActiveTheme (callback) {
    this.network.getActiveTheme((data, response)=> {
      return callback (data, response)
    })
  }

  getAccountDetails (slug, callback) {
    this.network.getAccountDetails(slug, (data, response)=> {
      return callback (data, response)
    })
  }

  updateAccount (slug, body, callback) {
    this.network.updateAccount (slug, body,(data, response) => {
        return callback (data, response)
    })
  }

  getUpdates (callback) {
    this.network.getUpdates ((data, response) => {
      return callback (data, response)
    })
  }

  setUpdates (body, callback) {
    this.network.setUpdates (body, (data, response) => {
      return callback (data, response)
    })
  }

  getWordPressSettings (callback) {
    this.network.getWordPressSettings((data, response) => {
      return callback (data, response)
    })
  }

  setWordPressSettings (opts,  callback) {
    this.network.setWordPressSettings(opts, (data, response) => {
      return callback (data, response)
    })
  }

  getNavigations (callback) {
    this.network.getNavigations ((data, response) => {
      return callback (data, response)
    })
  }

  getNavigationsSetting (callback) {
    this.network.getNavigationsSetting ((data, response) => {
      return callback (data, response)
    })
  }

  setNavigations (opts, callback) {
    this.network.setNavigations (opts, (data, response) => {
      return callback (data, response)
    })
  }

  localPackageGet (accountSlug, slug, callback) {
    this.network.localPackageGet (accountSlug, slug, (data, response) => {
      return callback (data, response)
    })
  }

  localClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
    this.network.localClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, (data, response) => {
      return callback (data, response)
    })
  }

  canonicalClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
    this.network.canonicalClone (accountSlug1, slug1, accountSlug2, slug2, body, opts, (data, response) => {
      return callback (data, response)
    })
  }

  localDelete (accountSlug, slug, body, callback) {
    this.network.localDelete (accountSlug, slug, body, (data, response) => {
      return callback (data, response)
    })
  }

  draftCreate (accountSlug, slug, body, opts, callback) {
    this.network.draftCreate (accountSlug, slug, body, opts, (data, response) => {
      return callback (data, response)
    })
  }

  localDownload (accountSlug, slug, opts, callback) {
    // this is for storing hash that use before saving package.
    this.backend.remove_package();
    let package_name = accountSlug + "/" + slug;
      this.controller.get_package(package_name, "jptf", null, true, false, (_project) => {
          let found = false;
          for (var key in _project[0]["/"]["content"]){
              if( Object.keys(_project[0]["/"]["content"][key])[0] === "_package.json"){
                found = true;
                break;
              }            
          }
          if(!found){
            return callback({}, {"status": 500});
          }
          return callback({}, {"status": 200, "text": JSON.stringify(_project) });
      });
  }

  localUpdate (accountSlug, slug, body, callback) {
    this.controller.localUpdate (accountSlug, slug, body, (data, response) => {
      return callback (data, response)
    })
  }

  canonicalSet (accountSlug, slug, body, callback) {
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response)
    } else {
      this.network.canonicalSet (accountSlug, slug, body, (data, response) => {
        return callback (data, response);
      });
    }
  }

  canonicalDetails (accountSlug, slug, callback) {
    this.network.canonicalDetails (accountSlug, slug, (data, response) => {
      return callback (data, response);
    })
  }

  sharedPackageListGet (accountSlug, slug, opts, callback){
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response)
    } else {
      this.network.sharedPackageListGet (accountSlug, slug, opts, (data, response) => {
        return callback (data, response);
      })
    }
  }

  sharePackage (accountSlug, slug, body, callback) {
    if(localStorage.getItem("session_key") === null){
      var data = {}, response = null;
      data.message = "No session_key";
      return callback(data, response)
    } else {
      this.network.packageShare (accountSlug, slug, body, (data, response) => {
        return callback (data, response);
      })
    }
  }

  revokeSharedPackage (accountSlug, slug,  body, callback) {
    this.network.revokeSharedPackage (accountSlug, slug, body, (data, response) => {
      return callback (data, response);
    })
  }

  verifyEmail (accountSlug, slug, email, callback) {
    this.network.verifyEmail (accountSlug, slug, email, (data, response) => {
      return callback (data, response);
    })
  }

  rejectPackage (accountSlug, slug, body, callback) {
    this.network.rejectPackage (accountSlug, slug, body, (data, response) => {
      return callback(data, response);
    })
  }

  searchAccounts (value, callback) {
    this.network.searchAccounts (value, (data, response) => {
      return callback (data, response);
    })
  }

  resendInvite (accountSlug, slug, body, callback) {
    this.network.resendInvite (accountSlug, slug, body, (data, response) => {
      return callback(data, response);
    })
  }

  versionList (accountSlug, slug, callback) {
    this.network.versionList (accountSlug, slug, (data, response) => {
      return callback (data, response);
    })
  }

  compareWithCanonical (accountSlug1, slug1, accountSlug2, slug2, callback) {
    this.network.compareWithCanonical (accountSlug1, slug1, accountSlug2, slug2, (data, response) => {
      return callback (data, response);
    });
  }

  compareWithDraft (accountSlug1, slug1, accountSlug2, slug2, callback) {
    this.network.compareWithDraft (accountSlug1, slug1, accountSlug2, slug2, (data, response) => {
      return callback (data, response);
    });
  }

  compareWithLocal (accountSlug1, slug1, accountSlug2, slug2, callback) {
    this.network.compareWithLocal (accountSlug1, slug1, accountSlug2, slug2, (data, response) => {
      return callback (data, response);
    });
  }

  compareWithVersion (accountSlug1, slug1, accountSlug2, slug2, label, callback) {
    this.network.compareWithVersion (accountSlug1, slug1, accountSlug2, slug2, label, (data, response) => {
      return callback (data, response);
    });
  }

  updateFromCanonical (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
    this.network.updateFromCanonical (accountSlug1, slug1, accountSlug2, slug2, body, opts, label, (data, response) => {
      return callback (data, response);
    });
  }

  updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
    this.network.updateFromDraft (accountSlug1, slug1, accountSlug2, slug2, body, opts, label, (data, response) => {
      return callback (data, response);
    });
  }

  updateFromLocal (accountSlug1, slug1, accountSlug2, slug2, body, opts, callback) {
    this.controller.updateFromLocal (accountSlug1, slug1, accountSlug2, slug2, body, opts, (data, response) => {
      return callback (data, response);
    });
  }

  updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, body, opts, callback) {
    this.controller.updateFromVersion (accountSlug1, slug1, accountSlug2, slug2, label, body, opts, (data, response) => {
      return callback (data, response);
    });
  }

  acceptAcquisition (accountSlug, slug, body, callback) {
    this.network.acceptAcquisition (accountSlug, slug, body, (data, response) => {
      return callback (data, response);
    })
  }

  getDependencies (accountSlug, slug, opts, callback) {
    this.network.getDependencies (accountSlug, slug, opts, (data, response) => {
      return callback (data, response);
    })
  }

}
 module.exports  = Main



/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Main.js
 **/